import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {MapperService} from '../../../services/mapper.service';
import {A0, PlanAction} from '../../../shared/entities/A0.entity';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {UploadDialogComponent} from '../upload-dialog/upload.dialog.component';


@Component({
    selector: 'app-enjeux',
    templateUrl: './enjeux.component.html',
    styleUrls: ['./enjeux.component.scss'],
    standalone: false
})
export class EnjeuxComponent implements OnInit {

  public urlIframe: SafeResourceUrl;
  public idMapA0: string;
  public plan: A0;
  public upload: any;

  constructor(
    private mapperService: MapperService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    public snackbar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.idMapA0 = this.route.snapshot.paramMap.get('id');
    this.getPlan(this.idMapA0);
  }

  public getPlan(id): void {
    this.mapperService.getPlan(id).subscribe(plan => {
      this.plan = plan;
      const url = this.plan.url_legend_dynamic;
      this.urlIframe = this.sanitizer.bypassSecurityTrustResourceUrl(url) ;
    });
  }

  public openModal(): void {
    this.dialog.open(UploadDialogComponent, {
      data: {
        title: '',
        content: `
            <p class="pb-0 mb-0">
               Voulez vous modifier la légende ?
               <br>
               Le document doit être un pdf de 570mm de haut pour 180mm de large.
            </p>
        `,
        plan: this.plan,
        planAction: PlanAction.ENJEUX
      },
      panelClass: 'dialog-warning',
      width: '600px'
    }).afterClosed().subscribe((update) => {
      if (update) {
        this.mapperService.listPlan = [];
        this.getPlan(this.idMapA0);
      }
    });
  }
}
